import { useRecordContext } from 'react-admin';

import { ClearAccountDataButton } from './ClearAccountDataButton';

import { checkAccess } from '../../../../../helpers/authUtils';

import { PLATFORMS } from '../../../../../config/constants/reportConstants';
import { USER_ROLES } from '../../../../../config/constants/authConstants';

export const ClearAccountDataButtonWrapper = () => {
    const record = useRecordContext();
    const { role } = JSON.parse(localStorage.getItem('user'));

    return record && [PLATFORMS.GOOGLE, PLATFORMS.META].includes(record.platform)
        && checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN] }) ?
        <ClearAccountDataButton record={record} /> : null;
};